var VehicleTrackModal = (function (base) {
  __extends(VehicleTrackModal, base);

  function VehicleTrackModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

  VehicleTrackModal.prototype.activate = function (vehicleId, vehicleName) {
    const self = this;

    this.loadContent(`api/vehicles/${vehicleId}/trackMap`, { vehicleName: vehicleName })
      .then($modal => {

        var containerHeight = $(window).height() * 0.65;
        $('#track-map', $modal).height(containerHeight);

        var track;
        var map;
        setTimeout(function () {
          var url = Url.action(`api/vehicles/${vehicleId}/track`);
          map = initVehicleTrackMap([{
            url: url,
            data: {
              from: $('#From', $modal).val(),
              to: $('#To', $modal).val()
            }
          }]);
        }, 200);

        $modal

          //
          .on('click', '[js=applyFilter]', function (e) {
            track = initTracksOnMapShowing(map, [{ 
              url: Url.action(`api/vehicles/${vehicleId}/track`),
              data: {
                from: $('#From', $modal).val(),
                to: $('#To', $modal).val()
              }
            }]);
          });
      });
  };

  function dataParse(start, stop) {
    var from = start.toISOString().split('-').join('').split(':').join('').replace('T', '');
    var to = stop.toISOString().split('-').join('').split(':').join('').replace('T', '');

    return [from.substring(0, from.length - 5), to.substring(0, to.length - 5)];
  }

  return VehicleTrackModal;
}(BaseModal));
